module.exports = __webpack_public_path__ + "img/hotel2_min.520c5b59.png";